import { useEffect, useState } from "react";

const useIsElementVisible = (ref: React.RefObject<HTMLElement>, shouldIntersect = true) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.02 },
    );

    if (ref.current) {
      shouldIntersect ? observer.observe(ref.current) : observer.unobserve(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref, shouldIntersect]);

  return isVisible;
};

export default useIsElementVisible;
